export const HOME_PAGE_FLOATING_NAV_BAR_CLICKED = 'Home Page Floating Nav Bar Clicked';

/** Canonical `Button Name` values: `More`, `Cart`, `Search`, `Profile` (pill + stuck bar only; not BS or Filters). */
export function homePageFloatingNavBarClickedEventProperties(options: {
  buttonName: string;
  sectionName: string;
}): Record<string, string> {
  return {
    'Button Name': options.buttonName,
    'Section Name': options.sectionName,
  };
}
